/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

export {
  drawerInputStyle as inputStyle,
  drawerLabelStyle as labelStyle,
  drawerErrorStyle as errorStyle,
} from '../../../../shared/styles/drawer-field-styles';

/**
 * Builds human-readable labels for recurrence frequencies from i18n.
 * @param t - The translation function.
 * @returns A map of frequency key to localized label.
 */
export function buildFreqLabels(t: (key: string) => string): Record<string, string> {
  return {
    none: t('form.freq_none'),
    daily: t('form.freq_daily'),
    weekly: t('form.freq_weekly'),
    monthly: t('form.freq_monthly'),
  };
}
